import React, { useState } from "react";
import { Plus } from "lucide-react";
import Reveal from "./Reveal";
import { FAQS } from "../../data/mock";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-28 md:py-40 border-b hairline">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-[0.85fr_1.15fr] gap-14">
        <div className="md:sticky md:top-24 self-start">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] mb-6">Questions Before You Apply</div>
          <Reveal>
            <h2 className="font-display text-[46px] md:text-[76px] leading-[0.98] tracking-[-0.03em]">
              What men <span className="italic-serif text-[var(--ember-3)]">actually</span> ask.
            </h2>
          </Reveal>
          <p className="mt-8 text-[var(--text-muted)] text-[15.5px] leading-[1.75] max-w-[420px]">Short answers. Straight answers. If you need more, we'll cover it on the Forge Call.</p>
        </div>

        <div className="border-t hairline">
          {FAQS.map((f, i) => {
            const active = open === i;
            return (
              <div key={i} className="border-b hairline">
                <button onClick={() => setOpen(active ? -1 : i)} className="w-full flex items-center justify-between gap-8 py-6 md:py-8 text-left group">
                  <span className={`font-display text-[22px] md:text-[30px] leading-[1.2] tracking-[-0.01em] transition-colors ${active ? "text-[var(--ember-3)]" : "text-[var(--text)] group-hover:text-[var(--ember-3)]"}`}>{f.q}</span>
                  <span className={`shrink-0 w-10 h-10 rounded-full border hairline-2 flex items-center justify-center transition-all duration-500 ${active ? "bg-[var(--ember-2)] border-[var(--ember-2)] text-[var(--bg)] rotate-45" : "text-[var(--text-muted)] group-hover:border-[var(--ember-2)] group-hover:text-[var(--ember-2)]"}`}>
                    <Plus size={18}/>
                  </span>
                </button>
                <div className={`overflow-hidden transition-[max-height,opacity] duration-700 ease-out ${active ? "max-h-[400px] opacity-100 pb-8" : "max-h-0 opacity-0"}`}>
                  <p className="text-[var(--text-muted)] text-[16px] leading-[1.8] max-w-[620px]">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
